import React, { createContext, useContext, useState } from "react";

const DriverTripContext = createContext();

// Custom hook to consume context
export const useDriverTrip = () => useContext(DriverTripContext);

export function DriverTripProvider({ children }) {
  const [trip, setTrip] = useState(null); // Initially null

  // Start a new trip
  const startTrip = (route, startKM) => {
    setTrip({
      route,
      status: "RUNNING",
      startKM,
      endKM: null,
      startTime: Date.now(),
      events: [],
      late: false,
      location: null,
    });
  };

  // End the current trip
  const endTrip = (endKM) => {
    setTrip((prev) =>
      prev
        ? { ...prev, status: "ENDED", endKM, endTime: Date.now() }
        : prev
    );
  };

  // Add an event (like Delay, Hazard, etc.)
  const addEvent = (type, note = "") => {
    setTrip((prev) =>
      prev
        ? {
            ...prev,
            events: [
              ...prev.events,
              { type, note, time: new Date().toLocaleTimeString() },
            ],
          }
        : prev
    );
  };

  // Toggle "Will Be Late" status
  const toggleLate = (value) => {
    setTrip((prev) => (prev ? { ...prev, late: value ?? !prev.late } : prev));
  };

  return (
    <DriverTripContext.Provider
      value={{ trip, startTrip, endTrip, addEvent, toggleLate }}
    >
      {children}
    </DriverTripContext.Provider>
  );
}
